import _ from 'underscore';
import React from 'react';
import { useFormService } from '../core/form-service';
import { useDataLoader } from '../data/use-data-loader';
import { useDataSaver } from '../data/use-data-saver';
import { FORM_STATES } from '../machine/machine-config';

const DataRepositoryInternal = () => {
  const { state, send, config: dynamicConfig } = useFormService();
  const config = _.get(state, ['context', 'config']);

  const { repository: useRepository } = config;
  const { repositoryProps } = dynamicConfig;

  const { load, save } = useRepository(repositoryProps);

  useDataLoader({ load, state, send });
  useDataSaver({ save, state, send });

  return null;
};

export const DataRepository = () => {
  const { state } = useFormService();
  const isFetching = state.matches(FORM_STATES.FETCHING);
  const config = _.get(state, ['context', 'config']);
  const { repositoryWrapper: RepositoryWrapper = React.Fragment } = config;

  return (!isFetching &&
    <RepositoryWrapper>
      <DataRepositoryInternal />
    </RepositoryWrapper>
  );
};
